import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { ROLE_LIST_COLUMN_LABEL_I18N_KEY } from '../role-list/role-list.config';
import { useRoleListContext } from '../role.context';

export const RoleListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useRoleListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={ROLE_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
